import { lazy, Suspense } from 'react';
import { PermissionGuard } from '@emfood/shared';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import { PERMISSIONS } from 'src/api/roles-config';
import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { UserListSearchParamsSchema } from 'src/sections/users/user-list/search-params';

import { rootRoute } from './root';

const InviteUser = lazy(() => import('src/sections/users/invite-user/view'));
const UserList = lazy(() => import('src/sections/users/user-list/view'));
const EditUser = lazy(() => import('src/sections/users/edit-user/view'));

// User Management routes
const userManagementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'user-managment',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <PermissionGuard requiredPermissions={[PERMISSIONS.USERS_READ]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </PermissionGuard>
    </AppAuthGuard>
  ),
});

const userManagementIndexRoute = createRoute({
  getParentRoute: () => userManagementRoute,
  path: '/',
  validateSearch: (search: unknown & SearchSchemaInput) =>
    UserListSearchParamsSchema.validateSync(search),
  component: UserList,
});

const inviteUserRoute = createRoute({
  getParentRoute: () => userManagementRoute,
  path: 'invite-user',
  component: InviteUser,
});

const editUserRoute = createRoute({
  getParentRoute: () => userManagementRoute,
  path: 'edit-user/$id',
  component: EditUser,
});

export const userManagementRouteTree = userManagementRoute.addChildren([
  userManagementIndexRoute,
  inviteUserRoute,
  editUserRoute,
]);
